module.exports = __webpack_public_path__ + "img/awareness_ribbon.a19ea0f2.png";